import { cn } from "@/lib/utils";
import { memo } from "react";

interface TanstackTableControlPanelProps {
  children: React.ReactNode;
  className?: string;
}

export const TanstackTableControlPanel = ({
  children,
  className,
}: TanstackTableControlPanelProps) => {
  return <div className={cn("flex items-center justify-between", className)}>{children}</div>;
};

export const MemoizedControlPanel = memo(
  TanstackTableControlPanel
) as typeof TanstackTableControlPanel;
